export default "__VITE_ASSET__aqVMin8X__"